'use strict';

angular.module(
    'core', [
        'core.contacts',
        'core.faq',
        'core.auth',
        'core.rent',
        'core.support'
    ]
);